import React, { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './ButtonTooltip.module.scss';
import Spinner from '../../../common/components/Spinner';
import Tooltip from '../Tooltip/Tooltip';

export const CustomButtonTooltip = ({
  children,
  onClick,
  disabled,
  customStyles,
  variant = 'primary',
  label,
  className,
  tooltipClassName,
  size,
  mini,
  disabledClassName,
  loading,
  loadingSpinner = false,
  loadingText,
  tooltip,
  moveableTooltip,
  ariaLabel = null,
}) => {
  const [isHover, setIsHover] = useState(false);

  const handleClick = () => {
    if (disabled) {
      return;
    }

    onClick();
  };

  const renderChildren = () => {
    if (loading) {
      if (loadingSpinner) {
        return <Spinner width="20px" height="20px" size="3px" />;
      }
      return loadingText;
    }

    if (label) {
      return label;
    }
    if (children) {
      return children;
    }
    return 'Button';
  };

  const _className = cx(className, styles[size], styles.button, styles[variant], {
    [styles.disabled]: disabled || loading,
    [disabledClassName]: disabled,
    [styles.mini]: mini,
  });

  return (
    <div className={styles.container} onMouseOver={() => setIsHover(true)} onMouseOut={() => setIsHover(false)}>
      <button className={_className} style={customStyles} onClick={handleClick} disabled={disabled || loading} {...(ariaLabel && { "aria-label": ariaLabel })}>
        {renderChildren()}
      </button>
      {disabled && !mini && tooltip ? (
        <Tooltip text={tooltip} isHover={isHover} classNameTooltip={tooltipClassName} moveable={moveableTooltip} position={'middle'} />
      ) : null}
    </div>
  );
};

CustomButtonTooltip.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  variant: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.string,
  disabledClassName: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  tooltip: PropTypes.string,
};

CustomButtonTooltip.defaultProps = {
  className: '',
  label: '',
  size: 'normal',
  variant: '',
  disabled: false,
  disabledClassName: '',
  loading: false,
  loadingText: 'Loading...',
  tooltip: '',
};
